import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useCheckMobileScreen from "../../utils/useCheckMobileScreen";
import GroupedBar from './GroupedBar';
import styled from "styled-components";
import { Button } from "react-bootstrap";
import { loadTenantActiveUsersBetweenDates, loadTenantActiveUsersBetweenDates2, loadTenantActiveUsersByDay, loadTenantActiveUsersByDay2 } from "../../app/actions"
import { MonthPicker } from "../dashboard/MonthPicker"
import moment from "moment"

const Card = styled.div`
box-shadow: 0px 1px 4px #c5c5c5;
-webkit-box-shadow: 0px 1px 4px #c5c5c5;
-moz-box-shadow: 0px 1px 4px #c5c5c5;
margin-bottom: 1em;
border-radius: 4px;
background: white;
`
const CardHeader = styled.div`
padding: 20px 16px;
font-size: 1.2em;
background-color: #f1f1f1;
color: #303030;
display: flex;
justify-content: space-between;
`
const ChartContainer = styled.div`
    padding: 20px;

    @media (max-width: 900px) {
        padding: 10px 10px 10px 5px;
        
    }
`

const DisplayWeek = styled.span`
    display: flex;
    align-items: center;
    font-weight: bold;
    color: #333;
`

function TenantActiveUsers({ tenant }) {

        const [toggleMonthPicker, setToggleMonthPicker] = useState(false);

        //Check if mobile screen
        const isMobileScreen = useCheckMobileScreen()
   
        //Dispatch
        const dispatch = useDispatch();

        //Redux store
        const activeUsers = useSelector(store => store.app.tenantActiveUsers)
        const activeUsers2 = useSelector(store => store.app.tenantActiveUsers2)
        
        //If desktop
        const firstDayOfMonthLastYear = moment().subtract(11, 'month').startOf("month").format("YYYY-MM-DD")
        const lastDayOfCurrentMonth = moment().endOf("month").format("YYYY-MM-DD")
        
        //If mobile
        //Current date
        const firstDayOfCurrentWeek = moment().startOf("week").format("YYYY-MM-DD");
        const lastDayOfCurrentWeek = moment().endOf("week").format("YYYY-MM-DD");
        //Current week
        const date = new Date;
        const year = date.getFullYear();
        const month = String(date.getMonth()+1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0')
        const todaysDate = year + '-' + month + '-' + day;
        let week = moment(todaysDate, "YYYY-MM-DD").week();
        
        const [index, setIndex] = useState("");
        
        //Date hooks on change date inputs
        const [fromDate, setFromDate] = useState(isMobileScreen ? firstDayOfCurrentWeek : firstDayOfMonthLastYear);
        const [toDate, setToDate] = useState(isMobileScreen ? lastDayOfCurrentWeek : lastDayOfCurrentMonth);
        const [weeknumber, setWeeknumber] = useState(week)

        let from = ""
        let to = "";

        if(fromDate) {
            from = fromDate
        } 

        if(toDate) {
            to = toDate
        } else {
            to = moment().format("YYYY-MM-DD")
        }

        let delimitor
        const diffInMonths = moment(to).diff(moment(from), "months", true)

        if(diffInMonths <= 2) {
            delimitor = {
                format: "Do",
                name: "day",
                plural: "days",
                text: "Försäljning per dag"
            }
        } else if(diffInMonths < 36 ){
            delimitor = {
                format: "MMM",
                name: "month",
                plural: "months",
                text: "Försäljning per månad"
            }
        } else {
            delimitor = {
                format: "YYYY",
                name: "year",
                plural: "years",
                text: "Försäljning per år"
            }
        }   

        let numberOfPeriodsInInterval = moment(to).diff(moment(from), delimitor.plural, true);
        //Quick fix, to add 1 day when displaying 1 month
        if(diffInMonths <= 2) {
           
            numberOfPeriodsInInterval += 1
        }
        const labels:any[] = [];
        const dates:any[] = [];
        const valuesActiveUsers:any[] = [];
        const valuesActiveUsers2:any[] = [];
        let it:any = moment(from);

        for(let i = 0; i < numberOfPeriodsInInterval; i++) {

            labels.push(it.format(delimitor.format))

            if(activeUsers && activeUsers.activeUsers && activeUsers2 && activeUsers2.activeUsers){

                valuesActiveUsers.push(
                    activeUsers.activeUsers
                    .filter(report => moment(report.created_at).isSame(it, delimitor.name))
                    .reduce((acc, curr) => acc + (+curr.ActiveUsers), 0)
                ) 
                
                valuesActiveUsers2.push(
                    activeUsers2.activeUsers
                    .filter(report => moment(report.created_at).add(1, 'year').isSame(it, delimitor.name))
                    .reduce((acc, curr) => acc + (+curr.ActiveUsers), 0)
                )
                
                dates.push(
                    activeUsers.activeUsers
                    .filter(report => {
                        if(moment(report.created_at).isSame(it, delimitor.name)){

                            return report.created_at
                        }
                        
                    })
                )
            }         
            it.add(1, delimitor.name);
        }

        const fetchReportsInInterval = (from, to) => {

            if(diffInMonths <= 2){
                dispatch(loadTenantActiveUsersByDay(from, to, tenant))
                dispatch(loadTenantActiveUsersByDay2(moment(from).subtract(1, 'year').format("YYYY-MM-DD"), moment(to).subtract(1, 'year').format("YYYY-MM-DD")))
            } else {
                dispatch(loadTenantActiveUsersBetweenDates(from, to, tenant))
                dispatch(loadTenantActiveUsersBetweenDates2(moment(from).subtract(1, 'year').format("YYYY-MM-DD"), moment(to).subtract(1, 'year').format("YYYY-MM-DD"), tenant))
            }
            
        }
   
        useEffect(() => {
                dispatch(loadTenantActiveUsersBetweenDates(fromDate, toDate, tenant))
                dispatch(loadTenantActiveUsersBetweenDates2(moment(fromDate).subtract(1, 'year').format("YYYY-MM-DD"), moment(toDate).subtract(1, 'year').format("YYYY-MM-DD"), tenant))
                
        }, [])

        const onNextClick = () => {

            let from = moment().day("sunday").week(weeknumber + 1).subtract(6, "day").format("YYYY-MM-DD")
            let to = moment().day("sunday").week(weeknumber + 1).format("YYYY-MM-DD")

            fetchReportsInInterval(from, to)

            setFromDate(from)
            setToDate(to)

            if (weeknumber >= 52) {
                setWeeknumber(1)
            }
            else {
                setWeeknumber(prev => prev + 1);
            } 
        }

        const onPrevClick = () => {
            
            let from = moment().day("sunday").week(weeknumber - 1).subtract(6, "day").format("YYYY-MM-DD")
            let to = moment().day("sunday").week(weeknumber - 1).format("YYYY-MM-DD")

            fetchReportsInInterval(from, to)

            setFromDate(from)
            setToDate(to)

            if (weeknumber <= 1) {
                setWeeknumber(52)
            }
            else {
                setWeeknumber(prev => prev - 1);
            }   
        }
        //When clicking on a bar in the bar chart, index is set to the index of that bar
        useEffect(() => {
     
            if(dates[index]){
                
                let fromDate = moment(dates[index][0].created_at, "YYYY-MM-DD").startOf("month").format("YYYY-MM-DD")
                let toDate = moment(dates[index][0].created_at, "YYYY-MM-DD").endOf("month").format("YYYY-MM-DD")
   
                setFromDate(fromDate)
                setToDate(toDate)
                dispatch(loadTenantActiveUsersByDay(fromDate, toDate, tenant))
                dispatch(loadTenantActiveUsersByDay2(moment(fromDate).subtract(1, 'year').format("YYYY-MM-DD"), moment(toDate).subtract(1, 'year').format("YYYY-MM-DD"), tenant))
            }
        }, [index])

        useEffect(() => {

            if(diffInMonths <= 2) {

                dispatch(loadTenantActiveUsersByDay(fromDate, toDate, tenant))
                dispatch(loadTenantActiveUsersByDay2(moment(fromDate).subtract(1, 'year').format("YYYY-MM-DD"), moment(toDate).subtract(1, 'year').format("YYYY-MM-DD"), tenant))
            } else if(diffInMonths < 36 ){

                dispatch(loadTenantActiveUsersBetweenDates(fromDate, toDate, tenant))
                dispatch(loadTenantActiveUsersBetweenDates2(moment(fromDate).subtract(1, 'year').format("YYYY-MM-DD"), moment(toDate).subtract(1, 'year').format("YYYY-MM-DD"), tenant))
            }
            
        }, [fromDate, toDate])

    return (
        <Card>
            <CardHeader>
                <div>Active users</div>
                {!isMobileScreen && 
                
                <div style={{ display: "flex", justifyContent: "center", }}>
                    <div style={{ width: "280px", cursor: "pointer" }} onClick={() => setToggleMonthPicker(true)}>{fromDate} - {toDate} <i className="fa fa-calendar" /></div>
                    {toggleMonthPicker &&
                        <MonthPicker
                            setFromDate={setFromDate}
                            setToDate={setToDate}
                            setToggleMonthPicker={setToggleMonthPicker}
                    />
                    }
                </div>
                }
                <div></div>
            </CardHeader>
            {isMobileScreen &&
            <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 10px 0px 10px" }}>
                <Button onClick={onPrevClick}><i className="fa fa-arrow-left"/></Button>
                <DisplayWeek>{`Week ${weeknumber}`}</DisplayWeek>
                <Button onClick={onNextClick}><i className="fa fa-arrow-right"/></Button>
          
            </div>
            }
    
            {!isMobileScreen &&
            <ChartContainer>
                <GroupedBar 
                    labels={labels}
                    valuesActiveUsers={valuesActiveUsers}
                    valuesActiveUsersOneYearBack={valuesActiveUsers2}
                    setIndex={setIndex}
                />
            </ChartContainer>
            } 
        
        </Card>
        
    )
}

export default TenantActiveUsers
